import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchShippingFees, updateShippingFee } from "./shippingFeesApi";

export const fetchShippingFeesThunk = createAsyncThunk(
    "shippingFees/fetchAll", 
    async (countryCodes, { rejectWithValue }) => {
    try {
        return await fetchShippingFees(countryCodes);
    } catch (error) {
        return rejectWithValue(error.message || "Failed to fetch shippingFees");
    }
});

export const updateShippingFeeThunk = createAsyncThunk(
    "shippingFees/update",
    async (payload, { rejectWithValue }) => {
        try {
            return await updateShippingFee(payload);
        } catch (error) {
            return rejectWithValue(error.message || "Failed to update shippingFee");
        }
    }
);